/** Monotonic epoch guard: `next()` starts a new epoch and returns its token; only the latest token is current. */
export function createSupersessionGuard(): {
  next: () => number;
  isCurrent: (token: number) => boolean;
  invalidate: () => void;
} {
  let current = 0;
  return {
    next: () => ++current,
    isCurrent: (token) => current === token,
    invalidate: () => {
      current++;
    },
  };
}
